import React, { FC, useEffect, useState } from "react";
import { fetchLangs, fetchUserSettings, updateSelectedLang } from "api";
import { Select } from "@axin-org/comet";
import { tw } from "twind";
import { useDispatch } from "react-redux";
import { UserSettingProps } from "types/UserSettings";

const SelectLang: FC = () => {
  const [langs, setLangs] = useState<{ value: string; label: string; baseValue: string }[]>([]);
  const [userSettings, setUserSettings] = useState<UserSettingProps | null>(null);
  const [selectedLang, setSelectedLang] = useState<string>("fr");

  const dispatch = useDispatch();

  useEffect(() => {
    fetchUserSettings()
      .then(response => {
        setUserSettings(response.data);
        setSelectedLang(response.data.lang);
      })
      .catch(error => {
        console.error("Failed to fetch user settings:", error);
      });

    fetchLangs()
      .then(response => {
        setLangs(response.data);
      })
      .catch(e => {
        console.error("error fetch user langs", e);
      });
  }, []);

  const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const val = event.target.value;
    const lang = langs.find(l => l.value === val);

    if (lang) {
      updateSelectedLang(lang.baseValue)
        .then(() => {
          dispatch({
            type: "UPDATE_SELECTED_LANG",
            payload: lang.baseValue
          });
          window.location.reload();
        })
        .catch(erreur => {
          console.log(erreur);
        });
    }
  };

  return (
    <Select
      id="changeLanguage"
      value={selectedLang}
      onChange={onChange}
      className={tw("bg-white text-black")}
    >
      {langs.map(lang => (
        <option key={lang.value} value={lang.value}>
          {lang.label}
        </option>
      ))}
    </Select>
  );
};

export default SelectLang;
